import {AbstractDrawPoint} from "../abstract-draw-point";

export class EditorDrawPoint extends AbstractDrawPoint {

}
